import Vue from "vue";
import { md5 } from '../md5local.js'


export default {
    version: "1.6",
    // BASE_URL: 'https://service.anvelopeinstoc.ro/dev/api/index.php',
    BASE_URL: 'https://service.anvelopeinstoc.ro/api/index.php',

    get_local_url() {
        var ret = window.location.origin;
        return ret;
    },

    get_key: function() {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < 30; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        var mdcheie = md5('fdsv8yrqhfdus'+ result + '35tfh&^H&^#');

        return {cheie: result, mdcheie: mdcheie};
    },

    set_token: function(newToken) {
        window.localStorage.setItem("service-evio-token", newToken);
        Vue.http.headers.common["Token"] = newToken;
    },
   
    get_token: function() {
        return window.localStorage.getItem("service-evio-token");
    },
    
    get_numeAgent: function() {
        return window.localStorage.getItem("service-evio-EsteAgent");
    },

    set_numeAgent: function(numeAgent) {
        if(numeAgent.trim().length < 1)
            window.localStorage.removeItem("service-evio-EsteAgent");
        else    
            window.localStorage.setItem("service-evio-EsteAgent", numeAgent);

    },

    set_drepturi: function (drepturi) {
        window.localStorage.setItem('service-evio-drepturi_user', JSON.stringify(drepturi));
    },

    get_drepturi: function () {
        var drepturi = window.localStorage.getItem('service-evio-drepturi_user');
        return JSON.parse(drepturi);
    },
    set_user_type: function (user_type) {
        window.localStorage.setItem('service-evio-user_type', user_type);
    },

    get_user_type: function () {
        return window.localStorage.getItem('service-evio-user_type');
    },

    is_logged_in: function() {
        var token = this.get_token();
        return token !== "";
    },

    logout: function() {
        this.set_token('');
        this.set_drepturi('');
    },

    verify_response: function(response) {
        if (response.body.NotLogged) {
            return false;
        }
        return true;
    },

    verify_login_and_redirect: function(vueInstance) {
        if (!this.is_logged_in()) {
            vueInstance.$router.push("/");
        }
    },
};
